const shippingCarrierOptions = [
  { label: '4PX', value: '4PX' },
  { label: 'APC', value: 'APC' },
  { label: 'Amazon Logistics UK', value: 'Amazon Logistics UK' },
  { label: 'Amazon Logistics US', value: 'Amazon Logistics US' },
  { label: 'Anjun Logistics', value: 'Anjun Logistics' },
  { label: 'Australia Post', value: 'Australia Post' },
  { label: 'Bluedart', value: 'Bluedart' },
  { label: 'Canada Post', value: 'Canada Post' },
  { label: 'Canpar', value: 'Canpar' },
  { label: 'China Post', value: 'China Post' },
  { label: 'Chukou1', value: 'Chukou1' },
  { label: 'Correios', value: 'Correios' },
  { label: 'Couriers Please', value: 'Couriers Please' },
  { label: 'DHL Express', value: 'DHL Express' },
  { label: 'DHL eCommerce', value: 'DHL eCommerce' },
  { label: 'DHL eCommerce Asia', value: 'DHL eCommerce Asia' },
  { label: 'DPD', value: 'DPD' },
  { label: 'DPD Local', value: 'DPD Local' },
  { label: 'DPD UK', value: 'DPD UK' },
  { label: 'Delhivery', value: 'Delhivery' },
  { label: 'Eagle', value: 'Eagle' },
  { label: 'FSC', value: 'FSC' },
  { label: 'Fastway Australia', value: 'Fastway Australia' },
  { label: 'FedEx', value: 'FedEx' },
  { label: 'GLS', value: 'GLS' },
  { label: 'GLS (US)', value: 'GLS (US)' },
  { label: 'Globegistics', value: 'Globegistics' },
  { label: 'Japan Post (EN)', value: 'Japan Post (EN)' },
  { label: 'Japan Post (JA)', value: 'Japan Post (JA)' },
  { label: 'La Poste', value: 'La Poste' },
  { label: 'New Zealand Post', value: 'New Zealand Post' },
  { label: 'Newgistics', value: 'Newgistics' },
  { label: 'PostNL', value: 'PostNL' },
  { label: 'PostNord', value: 'PostNord' },
  { label: 'Purolator', value: 'Purolator' },
  { label: 'Royal Mail', value: 'Royal Mail' },
  { label: 'SF Express', value: 'SF Express' },
  { label: 'SFC Fulfillment', value: 'SFC Fulfillment' },
  { label: 'Sagawa (EN)', value: 'Sagawa (EN)' },
  { label: 'Sagawa (JA)', value: 'Sagawa (JA)' },
  { label: 'Sendle', value: 'Sendle' },
  { label: 'Singapore Post', value: 'Singapore Post' },
  { label: 'StarTrack', value: 'StarTrack' },
  { label: 'TNT', value: 'TNT' },
  { label: 'Toll IPEC', value: 'Toll IPEC' },
  { label: 'UPS', value: 'UPS' },
  { label: 'USPS', value: 'USPS' },
  { label: 'Whistl', value: 'Whistl' },
  { label: 'Yamato (EN)', value: 'Yamato (EN)' },
  { label: 'Yamato (JA)', value: 'Yamato (JA)' },
  { label: 'YunExpress', value: 'YunExpress' },
  { label: 'Other', value: 'Other' },
];

export default shippingCarrierOptions;
